import { useEffect, useState } from "react";
import { WaitlistForm } from "@/components/WaitlistForm";
import { fetchWaitlistCount } from "@/lib/api";

export const WaitlistSection = () => {
  const [count, setCount] = useState(null);

  useEffect(() => {
    let alive = true;
    fetchWaitlistCount()
      .then((c) => {
        if (alive) setCount(c);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  return (
    <section
      id="waitlist"
      data-testid="waitlist-section"
      className="relative z-10 scroll-mt-20"
    >
      <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6 sm:py-24">
        <div className="grid gap-10 lg:grid-cols-[1fr_1fr] lg:gap-14">
          <div>
            <p className="eyebrow">Signal registry</p>
            <h2 className="mt-3 text-3xl font-semibold leading-tight sm:text-[2.6rem]">
              Be told the moment the next file unseals.
            </h2>
            <p className="mt-5 max-w-lg text-[15px] leading-relaxed text-[hsl(210_14%_84%)] sm:text-base">
              Books One and Two are out. One address, and you will be told the
              day each remaining file unseals — starting with{" "}
              <em className="not-italic text-[hsl(32_92%_66%)]">
                The Living War
              </em>{" "}
              on 11 January 2027. Nothing else, ever.
            </p>

            <ul className="mt-7 space-y-3">
              {[
                "A single message on each release day — four left",
                "First word when the sixth title is finally declassified",
                "Nothing sold, nothing shared, nothing forwarded"
              ].map((item) => (
                <li
                  key={item}
                  className="flex gap-3 text-sm leading-relaxed text-[hsl(210_12%_76%)]"
                >
                  <span className="mt-[9px] h-1 w-1 shrink-0 rounded-full bg-[hsl(174_72%_46%)]" />
                  {item}
                </li>
              ))}
            </ul>

            {count !== null && count >= 25 && (
              <p
                data-testid="waitlist-count"
                className="mt-7 font-mono text-[11px] uppercase tracking-[0.16em] text-muted-foreground"
              >
                Registry entries · {count.toLocaleString()}
              </p>
            )}
          </div>

          <div className="paper p-5 sm:p-7">
            <div className="flex items-center justify-between gap-3 border-b border-[hsl(36_18%_74%)] pb-3">
              <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[hsl(220_12%_38%)]">
                Form SR-01 · signal registration
              </p>
              <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[hsl(174_62%_28%)]">
                Open
              </p>
            </div>

            <h3 className="mt-5 text-xl font-semibold leading-tight text-[hsl(var(--ink))]">
              Register an address for release notification.
            </h3>

            <div className="mt-5">
              <WaitlistForm
                variant="paper"
                source="landing"
                idPrefix="waitlist"
                onJoined={() => setCount((c) => (c === null ? c : c + 1))}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
